import { Layers2 } from "lucide-react";

import { WizardDefinition } from "../framework/types";
import { wizardMascots } from "../mascots/mascots";
import { ADD_ENVIRONMENT_WIZARD_TYPE } from "./constants";
import { ChooseStep } from "./steps/ChooseStep";
import { SwitchStep } from "./steps/SwitchStep";
import { AddEnvironmentData, AddEnvironmentParams } from "./types";
import { useCompleteOnClose } from "./useCompleteOnClose";

export const addEnvironmentWizard: WizardDefinition<
  AddEnvironmentData,
  undefined,
  AddEnvironmentParams
> = {
  type: ADD_ENVIRONMENT_WIZARD_TYPE,
  title: "Add a project or environment",
  description:
    "Create a project for a new site, or a staging environment for testing, and install Freshpaint in it",
  Icon: Layers2,
  mascot: wizardMascots[ADD_ENVIRONMENT_WIZARD_TYPE],
  searchKeys: [
    "environment",
    "project",
    "staging",
    "development",
    "domain",
    "site",
    "new",
  ],
  createInitialData: (params) => ({
    target: params?.target ?? "environment",
    projectID: null,
    name: "",
    created: null,
  }),
  getSubtitle: (data) =>
    data.created
      ? `${data.created.projectName} › ${data.created.envName}`
      : undefined,
  getCompletionSummary: (data) => ({
    title: `${data.created?.envName ?? "It"} is ready`,
    description:
      "Switch to it from the environment picker at the top of the sidebar, then install Freshpaint in it.",
    highlights: data.created
      ? [`${data.created.projectName} › ${data.created.envName}`]
      : undefined,
  }),
  useStepContext: useCompleteOnClose,
  steps: [
    {
      id: "choose",
      phase: "Create",
      title: "Choose what to add",
      Component: ChooseStep,
    },
    {
      id: "switch",
      phase: "Switch",
      title: "Switch to it",
      Component: SwitchStep,
    },
  ],
};
